import { T } from './LanguageContext';
import { useEffect } from 'react';
import ketteraLogo from './images/kettera_logo.png';
import { ArrowLeft, Mail, Phone, Shield, CheckCircle, AlertTriangle, Mail as EnvelopeIcon } from 'lucide-react';


function FraudPrevention({ onBack }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);


  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Header fijo elegante */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl shadow-sm border-b border-gray-200">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="h-24 sm:h-28 md:h-32 flex items-center justify-between gap-6">
            <button 
              onClick={onBack}
              className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-2xl font-medium transition-all duration-300 group border border-transparent hover:border-blue-200"
            >
              <ArrowLeft className="w-5 h-5 transform group-hover:-translate-x-1 transition-transform duration-300" />
              <span className="hidden sm:inline text-lg">
                <T es="Volver al inicio" en="Back to home" />
              </span>
            </button>


            <a href="#" onClick={(e) => { e.preventDefault(); onBack(); }} className="absolute left-1/2 transform -translate-x-1/2">
              <img 
                src={ketteraLogo} 
                alt="Kettera" 
                className="h-20 sm:h-24 md:h-28 object-contain w-auto hover:scale-105 transition-transform duration-300"
              />
            </a>


            <div className="w-32"></div>
          </div>
        </div>
      </header>


      <div className="h-24 sm:h-28 md:h-32"></div>


      {/* Hero Section */}
      <section className="relative pt-16 pb-20 bg-white overflow-hidden">
        <div className="max-w-[900px] mx-auto px-6 md:px-12 relative z-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-gray-900 text-center mb-6 tracking-tight animate-fadeIn">
            <T es="Prevención de Fraudes" en="Fraud Prevention" />
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-[#2B6CB0] to-[#3182CE] mx-auto rounded-full mb-4 animate-fadeIn"></div>
          <p className="text-center text-gray-600 text-xl max-w-2xl mx-auto animate-fadeIn">
            <T es="En Kettera, tu seguridad es nuestra certeza." en="At Kettera, your security is our certainty." />
          </p>
        </div>
      </section>


      {/* Contenido principal */}
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <article className="space-y-8 text-gray-700 text-lg leading-relaxed">
            
            {/* Introducción */}
            <div className="bg-blue-50 border-l-4 border-blue-600 p-8 rounded-r-3xl shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
              <p className="text-gray-800 text-justify text-lg leading-relaxed">
                Comprendemos los intentos de fraude en la industria financiera y queremos garantizarte una colaboración totalmente segura. Te compartimos pautas esenciales para identificar a Kettera y nuestros representantes:
              </p>
            </div>
            <div className="space-y-6">
              {/* Tarjeta 1 */}
              <div className="bg-white border border-blue-100 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 flex items-center gap-6">
                <div className="flex-shrink-0">
                  <CheckCircle className="w-12 h-12 text-blue-600" />
                </div>
                <p className="text-gray-800 text-base leading-relaxed">
                  En Kettera, nos especializamos en apoyar a empresas legales con soluciones financieras. No otorgamos préstamos a individuos.
                </p>
              </div>
              {/* Tarjeta 2 */}
              <div className="bg-white border border-blue-100 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 flex items-center gap-6">
                <div className="flex-shrink-0">
                  <AlertTriangle className="w-12 h-12 text-red-600" />
                </div>
                <p className="text-gray-800 text-base leading-relaxed">
                  Jamás solicitamos pagos anticipados por nuestros productos. Esta política es inviolable.
                </p>
              </div>
              {/* Tarjeta 3 */}
              <div className="bg-white border border-blue-100 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 flex items-center gap-6">
                <div className="flex-shrink-0">
                  <EnvelopeIcon className="w-12 h-12 text-green-600" />
                </div>
                <p className="text-gray-800 text-base leading-relaxed">
                  Nuestros correos de contacto oficial solamente tienen el siguiente dominio: <a href="mailto:ejemplo@ketterafs.com" className="text-blue-600 underline hover:text-blue-700 font-semibold transition-colors">ejemplo@ketterafs.com</a>
                </p>
              </div>

            </div>
            {/* Texto informativo */}
            <div className="bg-gradient-to-br from-blue-50/50 via-white to-indigo-50/50 border border-blue-100 rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-500">
              <p className="text-gray-800 text-base leading-relaxed text-justify">
                Si percibes cualquier comunicación sospechosa relacionada con Kettera, te instamos a contactarnos de inmediato. Escríbenos a <a href="mailto:aml-pld@ketterafs.com" className="text-blue-600 underline hover:text-blue-700 font-semibold transition-colors">aml-pld@ketterafs.com</a> para que lo incluyamos en nuestras investigaciones y acciones legales correspondientes.
              </p>
            </div>
            {/* Mensaje de cierre */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 flex items-center justify-center">
            <p className="text-white text-center text-2xl font-semibold leading-relaxed m-0">
                En Kettera, velamos por tu seguridad en cada paso. Tu confianza es nuestra principal misión.
            </p>
            </div>
          </article>

          {/* CONTACTOS */}
          <div className="mt-20 bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-50 rounded-3xl p-12 border border-blue-100 shadow-2xl hover:shadow-3xl transition-all duration-500 relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-blue-200/20 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-indigo-200/20 to-transparent rounded-full blur-3xl"></div>
            <div className="relative z-10">
              <h3 className="text-5xl font-bold text-gray-900 mb-10 text-center animate-fadeIn">
                Contacto
              </h3>
              <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
                <a href="mailto:aml-pld@ketterafs.com" className="flex flex-col items-center gap-4 p-8 bg-white rounded-3xl hover:shadow-2xl transition-all duration-500 border border-blue-100 hover:border-blue-300 hover:-translate-y-2 group/card">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white group-hover/card:scale-110 group-hover/card:rotate-6 transition-all duration-500 shadow-lg">
                    <Mail className="w-8 h-8" />
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-gray-500 font-medium mb-2 uppercase tracking-wide">
                      Correo electrónico
                    </p>
                    <p className="text-blue-600 font-semibold text-xl group-hover/card:text-blue-700 transition-colors">
                      aml-pld@ketterafs.com
                    </p>
                  </div>
                </a>
                <a href="tel:+525549528609" className="flex flex-col items-center gap-4 p-8 bg-white rounded-3xl hover:shadow-2xl transition-all duration-500 border border-blue-100 hover:border-blue-300 hover:-translate-y-2 group/card">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white group-hover/card:scale-110 group-hover/card:rotate-6 transition-all duration-500 shadow-lg">
                    <Phone className="w-8 h-8" />
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-gray-500 font-medium mb-2 uppercase tracking-wide">
                      Teléfono
                    </p>
                    <p className="text-blue-600 font-semibold text-xl group-hover/card:text-blue-700 transition-colors">
                      55 4952 8609
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer con línea final */}
      <div className="w-full flex justify-center my-20">
        <div className="h-1 w-1/2 bg-gradient-to-r from-[#2B6CB0]/0 via-[#2B6CB0]/30 to-[#3182CE]/0 rounded-full"></div>
      </div>


    </div>
  );
}


export default FraudPrevention;
